import React__default from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox.js';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

function CheckboxGroup(props) {
  var label = props.label,
    className = props.className,
    required = props.required,
    showError = props.showError,
    errorMessage = props.errorMessage,
    disabled = props.disabled,
    options = props.options;
  var checkboxGroupClasses = "bf-form-element-wrapper \n        bf-checkbox-group-wrapper\n        ".concat(required ? 'bf-form-element-is-required' : '', " \n        ").concat(showError ? 'bf-form-element-has-error' : '', "\n        ").concat(className, " \n    ");
  return /*#__PURE__*/React__default.createElement("div", {
    className: checkboxGroupClasses
  }, label ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "bf-form-element-label"
  }, label)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-checkbox-group-options-wrapper"
  }, options.map(function (option, index) {
    var key = "OPTION_".concat(index);
    return /*#__PURE__*/React__default.createElement(Checkbox, {
      defaultChecked: option.defaultChecked,
      disabled: disabled || option.disabled,
      name: option.name,
      label: option.label,
      key: key
    });
  })), showError && errorMessage ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-error-message"
  }, errorMessage) : null);
}
CheckboxGroup.defaultProps = {
  label: '',
  className: '',
  required: false,
  showError: false,
  errorMessage: '',
  disabled: false
};
CheckboxGroup.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  showError: PropTypes.bool,
  errorMessage: nodeOrStringProp,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string.isRequired
  })).isRequired
};

export default CheckboxGroup;
